import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const AerosoftCrjMarketingSeo = (): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="Single-pilot ops simplified">
        <Text fz="medium">
          Aerosoft's CRJ is great for quick legs, where there isn't much time to prepare between
          departure and arrival. Whether you're on the 550, 700, 900, or 1000, having a quick
          reference checklist helps you operate the flight with confidence. <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection title="Go ahead, skip the safety check">
        <Text fz="medium">
          Use our CRJ checklist or make it your own using the web-based editor. Extend the checklist
          to cover ground handling, ATC, and other addon software. Color-code or bold important
          memory items. Download your checklist as a PDF or share a link to it with your virtual
          airline. Checklists are saved in your browser, so you can come back and adjust them later.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
